import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Check, ArrowRight, Crown, HelpCircle } from "lucide-react";

const chooseLottae = [
  "You're budget-conscious and want the best per-user value",
  "You need full features without paying for enterprise tiers",
  "White-labeling or custom domains are important",
  "Your team is growing and you want predictable scaling costs",
  "Customization and workflow flexibility matter most",
  "You prefer transparent, storage-based pricing",
];

const considerAlternatives = [
  { condition: "Heavy Atlassian ecosystem user", suggestion: "Consider Jira" },
  { condition: "Need 1000+ native integrations", suggestion: "Jira has the largest library" },
  { condition: "Simple kanban is all you need", suggestion: "Trello free tier works" },
  { condition: "Docs + projects in one place", suggestion: "Notion might suit better" },
  { condition: "Visual-first team workflows", suggestion: "Monday.com excels here" },
  { condition: "Enterprise compliance requirements", suggestion: "Check specific vendor certifications" },
];

export const PMToolsDecisionGuide = () => {
  return (
    <section className="py-8">
      <div className="space-y-4 mb-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-foreground">
          Decision Guide: Which Tool Should You Choose?
        </h2>
        <p className="text-muted-foreground">
          Quick recommendations based on your team's specific needs
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {/* Choose Lottae */}
        <Card className="border-2 border-primary bg-primary/5">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-lg sm:text-xl">
              <Crown className="w-5 h-5 text-yellow-500" />
              Choose Lottae when...
            </CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-3">
              {chooseLottae.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                  <span className="text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>

        {/* Consider alternatives */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-lg sm:text-xl">
              <HelpCircle className="w-5 h-5 text-muted-foreground" />
              Consider alternatives when...
            </CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-3">
              {considerAlternatives.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <ArrowRight className="w-5 h-5 text-muted-foreground shrink-0 mt-0.5" />
                  <div>
                    <span className="text-muted-foreground">{item.condition}</span>
                    <span className="text-foreground font-medium"> → {item.suggestion}</span>
                  </div>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
